import React, {useEffect, useState} from "react";
import Page from "../Components/Page";
import {Breadcrumbs} from "../Components/Breadcrumbs";
import {makeApiCall} from "../../Api/makeApiCall";
import {LoadingWrapper} from "../Components/LoadingWrapper";
import PeriodsDropdown from "../Components/Dropdowns/PeriodsDropdown";
import ButtonLoader from "../../utils/components/ButtonLoader";
import {invokeDAGviaApiPost} from "../../Api/invokeDag";
import {getUserEmail} from "../../auth/accessTokenValidator";
import AirflowDagLogs from "../Components/airflow/dagLogs/AirflowDagLogs";
import {convertGsutilPathToBrowserGcsUrl} from "../../utils/gcsUtils";


export const ProjectionFactors = () => {
    const [projectionFactorsCurrentPeriod, setProjectionFactorsCurrentPeriod] = useState(undefined);
    const [autoAddCells, setAutoAddCells] = useState(undefined);
    const [autoAddCellDetails, setAutoAddCellDetails] = useState([]);
    const [selectedPeriod, setSelectedPeriod] = useState(undefined);

    const GENERATE_PROJECTION_FACTORS_IN_OPS_PORTAL_DAG_ID = 'generate_projection_factors_in_ops_portal'
    useEffect(() => {
        Promise.all([
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/projectionFactors/currentPeriod`),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/projectionFactorsAutoAddCells`),
        ])
        .then(([
            currentPeriodResponse,
            autoAddCellsResponse
        ]) => {
            setProjectionFactorsCurrentPeriod(currentPeriodResponse)
            setSelectedPeriod(currentPeriodResponse.toString());
            setAutoAddCells(autoAddCellsResponse.data)

        });
    },[])

    useEffect(() => {
        if (autoAddCells) {
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/projectionFactors/cells?cell_ids=${autoAddCells.map(cell=>cell.cellId).join(",")}`)
                .then(response => setAutoAddCellDetails(response.map(item=>item.cell_tag+" - "+item.description)))
        }
    }, [autoAddCells]);
    const periodsFunction = (result)=> {
        return result.periods.filter(period => period.legacyPeriod <= parseInt(projectionFactorsCurrentPeriod)).map(period=> ({periodAbbreviation: period.legacyPeriod.toString()}))
    };

    return (
        <Page breadCrumbs={<Breadcrumbs items={[{label: "Services"}, {label: "Projections"}, {label: "Projection Factors"}]}/>} beta name={"Projection Factors"}>
            <div className={'project-factors-page-controls'}>
                <div className={'left-things'}>
                    <div className={'legacy_period-wrapper'}>
                        <LoadingWrapper loading={!projectionFactorsCurrentPeriod && !autoAddCellDetails}>
                            <div data-testid={'projection_factors_periods'}>
                                {projectionFactorsCurrentPeriod &&
                                    <PeriodsDropdown
                                        id={'projection_factors_periods'}
                                        data-testid={'projection_factors_periods'}
                                        className={'data-row_dropdown'}
                                        updatePeriod={(selectedPeriod) => setSelectedPeriod(selectedPeriod)}
                                        periodLabel={'Projection Factor Period'}
                                        selectedPeriod={selectedPeriod}
                                        graphqlQuery={'{periods(periodEndWeeksOnly:true) {legacyPeriod}}'}
                                        periodsFunction={periodsFunction}
                                    />

                                }
                            </div>


                            <div className={'missing-data-action-buttons'}>
                                <ButtonLoader
                                    buttonTitle={"Generate Projection Factor"}
                                    buttonHasModal
                                    buttonClassName={"button primary "}
                                    modalText={`Are you sure you want to trigger ${GENERATE_PROJECTION_FACTORS_IN_OPS_PORTAL_DAG_ID}?\n Auto Add Cells are \n ${autoAddCellDetails.map(item=>item.toString()+'\n')}`}
                                    axiosFunction={() => invokeDAGviaApiPost(GENERATE_PROJECTION_FACTORS_IN_OPS_PORTAL_DAG_ID,
                                        {
                                            runBy: getUserEmail(),
                                            period_id: parseInt(selectedPeriod)
                                        }
                                    )}
                                    toastTextFailure={`${GENERATE_PROJECTION_FACTORS_IN_OPS_PORTAL_DAG_ID} DAG trigger failed with error`}
                                    toastTextSuccess={`${GENERATE_PROJECTION_FACTORS_IN_OPS_PORTAL_DAG_ID} DAG triggered successfully`}
                                />
                            </div>
                        </LoadingWrapper>
                    </div>
                </div>
            </div>
                <AirflowDagLogs
                    processName={GENERATE_PROJECTION_FACTORS_IN_OPS_PORTAL_DAG_ID}
                    includeDagName={false}
                    includeVersion={true}
                    customColumns={
                        [
                            {
                                header: 'Output File',
                                accessorKey: 'runid',
                                cell: ({getValue}) => {
                                    const gsLinkPrefix = `gs://spins-edp-${process.env.REACT_APP_ENV}-data-test/p_dataset=${GENERATE_PROJECTION_FACTORS_IN_OPS_PORTAL_DAG_ID}/`

                                    return <a href={convertGsutilPathToBrowserGcsUrl(`${gsLinkPrefix}${getValue()}/`)}
                                              target="_blank" rel="noopener noreferrer">store-missing-pfactor.csv</a>;
                                },
                            }]
                    }
                />
        </Page>
    );
}
